import {
  Board,
  BoardHeader, BoardSearchDetail,
  BoardSearchResult,
  CancelButton,
  ColSpan2,
  ColSpan4,
  Input,
  RowSpan,
  Span4,
  SubmitButton,
  SubmitContainer
} from "../../../assets/GlobalStyles";
import React, {useEffect, useState} from "react";
import {HorizontalRule} from "../../../components/common/Common";
import {AdverInfo, Row, ValueText} from "../styles/common";
import {useAtom} from "jotai";
import {stepCampaignAtom} from "../entity";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
  decimalFormat,
  isUnlimited,
  sortingAgentType
} from "../../../common/StringUtils";
import {
  deleteCampaign,
  retrieveAdverConfirm,
  retrieveConfirm, selAdverEnumInfo, updateCampaignDefaultInfo,
} from "../../../services/campaign/ConfirmAxios";
import {tokenResultAtom} from "../../login/entity/Common";
import {selEnumInfo} from "../../../services/campaign/InfoAxios";
import {toast} from "react-toastify";
import {campaignBasicInfoAtom} from "../entity/Info";
import {useResetAtom} from "jotai/utils";
import queryString from "query-string";
import {DeleteUser} from "../../../components/common/DeleteUser";

export function CampaignLookOver() {
  const location = useLocation()
  const navigate = useNavigate()
  const [campaignBasicInfo] = useAtom(campaignBasicInfoAtom)
  const [, setStepCampaign] = useAtom(stepCampaignAtom)
  const [campaignData, setCampaignData] = useState(null)
  const [campaignName, setCampaignName] = useState('')
  const [userTargetConfig, setUserTargetConfig] = useState([])
  const [audienceTargetConfig, setAudienceTargetConfig] = useState([])
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [agentTypeState, setAgentTypeState] = useState([])
  const resetBasicInfo = useResetAtom(campaignBasicInfoAtom)
  const state = location.search !== '' ? queryString.parse(location.search)
      : location.state

  const inventoryExposure = (inventoryDetail) => {
    if (inventoryDetail == null) {
      return;
    }
    setUserTargetConfig(
        [
          inventoryDetail.exposureConversionUserYn === 'Y' ? '전환 고객 노출'
              : `전환 고객 미노출[${inventoryDetail.nonExposureDaysOfConversionUser
              !== null ? inventoryDetail.nonExposureDaysOfConversionUser : 0}일]`,
          inventoryDetail.exposureShoppingUserYn === 'Y' ? '쇼핑 고객 노출'
              : '쇼핑 고객 미노출',
          inventoryDetail.exposureAttentionUserYn === 'Y' ? '관심 고객 노출'
              : '관심 고객 미노출',
          inventoryDetail.exposureVisitUserYn === 'Y' ? '방문 고객 노출' : '방문 고객 미노출'
        ]
    )
    setAudienceTargetConfig(
        [
          inventoryDetail.exposureConversionAudienceYn === 'Y' ? '전환 유저 노출'
              : `전환 유저 미노출[${inventoryDetail.nonExposureDaysOfConversionAudience
              !== null ? inventoryDetail.nonExposureDaysOfConversionAudience
                  : 0}일]`,
          inventoryDetail.exposureShoppingAudienceYn === 'Y' ? '쇼핑 유저 노출'
              : '쇼핑 유저 미노출',
          inventoryDetail.exposurePotentialAudienceYn === 'Y' ? '잠재 유저 노출'
              : '잠재 유저 미노출',
          inventoryDetail.exposureNewAudienceYn === 'Y' ? '신규 유저 노출'
              : '신규 유저 미노출'
        ]
    )
  }
  useEffect(() => {
    if (tokenUserInfo.role !== 'NORMAL') {
      selEnumInfo('AGENT_TYPE').then(response => {
        setAgentTypeState(response.values)
      })
      let campaignId = (state !== null ? state.campaignId
          : campaignBasicInfo.campaignId);
      if (campaignId != null) {
        retrieveConfirm(campaignId).then(response => {
          setCampaignData({
            ...response
          })
          setCampaignName(response.name)
          inventoryExposure(response.inventoryDetail)
        })
      }
    } else {
      selAdverEnumInfo('AGENT_TYPE').then(response => {
        setAgentTypeState(response.data)
      })
      retrieveAdverConfirm(state.campaignId).then(response => {
        setCampaignData({
          ...response
        })
        inventoryExposure(response.inventoryDetail)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChangeName = (e) => {
    setCampaignName(e.target.value)
  }

  const onCancel = () => {
    if (state !== null) {
      navigate(-1)
    } else {
      resetBasicInfo();
      setStepCampaign({steps: 0})
    }
  }
  /**
   * 캠페인 삭제
   * @param delYn
   */
  const handleDelYn = (delYn) => {
    if (delYn === 'Y') {
      deleteCampaign(state.campaignId, campaignName).then(
          () => navigate(-1));
    }
  }
  const goalInfoLabel = (goalInfoValue) => {
    if (goalInfoValue.includes('ROAS')) {
      return '%'
    } else if (goalInfoValue.includes('매출') || goalInfoValue.includes('단가')
        || goalInfoValue.includes('금액')) {
      return '원'
    } else if (goalInfoValue.includes('카운트') && ![goalInfoValue].includes(
        '노출 카운트')) {
      return '건'
    } else {
      return '회'
    }
  }

  const onSubmit = () => {
    campaignName !== '' ? updateCampaignDefaultInfo(state.campaignId,
        campaignName).then(response => {
      if (response) {
        toast.success("캠페인명이 수정되었습니다.",
            {autoClose: 100, delay: 0, toastId: 'updateCampaign'})
        toast.onChange(payload => {
          if (payload.status === "removed" && payload.type !== toast.TYPE.ERROR
              && payload.id === 'updateCampaign') {
            navigate('/board/dashboard')
          }
        })
        resetBasicInfo();
      } else {
        toast.error('캠페인명 수정이 실패하였습니다.')
      }
    }) : toast.warning('캠페인명을 입력해주세요.')
  }

  return (
      <>
        {state !== null && <AdverInfo><span>광고주 정보</span><p></p>
          <span>{state?.adverInfo}</span></AdverInfo>}
        <Board>
          <BoardHeader>캠페인 검토</BoardHeader>
          {campaignData !== null &&
              <BoardSearchResult>
                <RowSpan>
                  <Span4>캠페인 기본 정보</Span4>
                </RowSpan>
                <RowSpan box={true} column={true}>
                  <Row>
                    <ColSpan4>
                      <Span4>캠페인명</Span4>
                      {
                        (tokenUserInfo.role !== 'NORMAL' && state !== null) ?
                            <Input value={campaignName}
                                   onChange={handleChangeName}/>
                            :
                            <ValueText>{campaignData.name}</ValueText>
                      }
                    </ColSpan4>
                  </Row>
                  <Row>
                    <ColSpan2>
                      <Span4>캠페인 상품</Span4>
                      <ValueText>{campaignData.productType}</ValueText>
                    </ColSpan2>
                    <HorizontalRule/>
                  </Row>
                </RowSpan>
                <RowSpan>
                  <Span4>예산 및 입찰 설정</Span4>
                </RowSpan>
                <RowSpan box={true} column={true}>
                  <Row>
                    <ColSpan2>
                      <Span4>일일 평균 예산</Span4>
                      <ValueText>{campaignData.infiniteBudgetYn !== 'N' ? '무제한'
                          : decimalFormat(campaignData.dailyAvgBudget)
                          + '원'}</ValueText>
                    </ColSpan2>
                    <HorizontalRule/>
                    <ColSpan2>
                      <Span4>예산 비율</Span4>
                      <ValueText>{campaignData.infiniteBudgetYn !== 'N' ? '무제한'
                          : ('PC\u0009' + decimalFormat(campaignData.pcBudget)
                              + '원 / MOBILE\u0009' + decimalFormat(
                                  campaignData.mobBudget) + '원')}</ValueText>
                    </ColSpan2>
                  </Row>
                  <Row>
                    <ColSpan2>
                      <Span4>시간별 예산 그룹</Span4>
                      <ValueText>{campaignData?.budgetTimeName}</ValueText>
                    </ColSpan2>
                  </Row>
                  <Row>
                    <ColSpan2>
                      <Span4>입찰 방식</Span4>
                      <ValueText>{campaignData.biddingType}</ValueText>
                    </ColSpan2>
                    <HorizontalRule/>
                    <ColSpan2>
                      <Span4>입찰 단가</Span4>
                      <ValueText>{campaignData?.biddingPrice}</ValueText>
                    </ColSpan2>
                  </Row>
                </RowSpan>
                <RowSpan>
                  <Span4>광고 그룹 설정</Span4>
                </RowSpan>
                <RowSpan box={true} column={true}>
                  {campaignData.inventoryDetail != null ?
                      <>
                        <Row>
                          <ColSpan2>
                            <Span4>노출 영역</Span4>
                            <ValueText>{campaignData.inventoryDetail != null
                            && campaignData.inventoryDetail?.exposureAgentType.length
                            !== agentTypeState?.length ?
                                sortingAgentType(
                                    campaignData.inventoryDetail?.exposureAgentType).map(
                                    d => d.label).join(', ') : '전체'
                            }
                            </ValueText>
                          </ColSpan2>
                        </Row>
                        <Row>
                          <ColSpan2>
                            <Span4>게재 지면</Span4>
                            <ValueText>
                              {
                                campaignData.inventoryDetail?.exposureInventoryType
                                !== 'MANUAL' ?
                                    (campaignData.inventoryDetail?.exposureInventoryType
                                    !== 'AUTO' ? '카테고리 설정' : '자동 최적화')
                                    : `${campaignData.inventoryDetail?.allowInventoryIds.length} 개 지면 게재 설정`
                              }
                            </ValueText>
                          </ColSpan2>
                          <HorizontalRule/>
                          <ColSpan2>
                            <Span4>게재 기간</Span4>
                            <ValueText>{campaignData.inventoryDetail?.startDate} ~ {isUnlimited(
                                campaignData.inventoryDetail?.endDate)}</ValueText>
                          </ColSpan2>
                        </Row></> :
                      <Row style={{justifyContent: 'center'}}>
                        <ColSpan2 style={{justifyContent: 'center'}}>
                          <ValueText>
                            <Link to={{pathname:'/board/campaignThree', search: `campaignId=${state?.campaignId}&adverInfo=${state?.adverInfo}`}} state={{campaignId: state?.campaignId, adverInfo: state?.adverInfo}} className={'line-clamp_2'}>광고 게재 설정</Link>
                          </ValueText>
                        </ColSpan2>
                      </Row>
                  }
                </RowSpan>
                <RowSpan>
                  <Span4>소재 설정</Span4>
                </RowSpan>
                <RowSpan box={true} column={true}>
                  <Row>
                    <ColSpan2>
                      <Span4>소재 정보</Span4>
                      <ValueText>{campaignData.creativeType}</ValueText>
                    </ColSpan2>
                  </Row>
                </RowSpan>
              </BoardSearchResult>
          }
        </Board>
        {tokenUserInfo.role === 'SUPER_ADMIN' &&
            <Board>
              <BoardHeader>{"캠페인 삭제"}</BoardHeader>
              <BoardSearchDetail>
                <RowSpan>
                  <DeleteUser title={"캠페인 삭제"} onSubmit={handleDelYn}
                              btnStyle={'SearchUser'}/>
                </RowSpan>
              </BoardSearchDetail>
            </Board>
        }
        <SubmitContainer>
          <CancelButton type={'button'}
                        onClick={() => onCancel()}>{(tokenUserInfo.role
              !== 'NORMAL' && state !== null) ? '목록' : '확인'}</CancelButton>
          {tokenUserInfo.role !== 'NORMAL' && state !== null &&
              <SubmitButton type={'button'}
                            onClick={() => onSubmit()}>저장</SubmitButton>}
        </SubmitContainer>

      </>
  )
}